<template>
  <div id="pmlst-questionlist">
    <div class="pmlst-questionlist-wrapper">
      <transition-group
        name="question"
        tag="ol"
        class="pmlst-questionlist-list"
      >
        <li v-for="question in questions" :key="question.id">
          <question :question="question" />
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Question from '@/components/Question'

export default {
  name: 'pure-question-list',
  components: {
    Question
  },
  props: {
    questionlist: {
      type: Object,
      required: true
    }
  },
  computed: {
    questions() {
      return this.$props.questionlist.questions
    }
  }
}
</script>
